import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { AsyncMessage } from '../../components/async-message.js';

export function RouteErrorScreen() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Erreur de navigation inconnue.';

  return <AsyncMessage kind="error" message={message} title="Impossible d’afficher cette page" />;
}
